import client from "../client";
import { QuotationRequestInterface } from "../../models/ProcurementModule/QuotationRequest";

class QuotationRequestService {
  async ApproveQuotationRequest(id: string | undefined) {
    try {
      const { data } = await client.post<QuotationRequestInterface>(
        `/api/QuotationRequests/approve/${id}`,
        { url: "" }
      );

      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
  async GetAll(
    purchaseOrderId: string | undefined,
    page: number,
    pageSize: number
  ) {
    try {
      const { data } = await client.post<QuotationRequestInterface[]>(
        `/api/QuotationRequests/get`,
        {
          page,
          pageSize,
          purchaseOrderId,
        }
      );

      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async GetById(id: string | undefined) {
    try {
      const { data } = await client.get<QuotationRequestInterface>(
        `/api/QuotationRequests/getbyid/${id}`
      );

      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async Create(
    item: QuotationRequestInterface,
    fileNames: {
      fileUrl: string;
      fileName: string;
    }[]
  ) {
    try {
      const url = `/api/QuotationRequests/create`;

      const { files, id, vendor, ...formData } = item;

      const form = new FormData();

      for (const key in formData) {
        if (key !== "uploadFiles") {
          // Skip formImages for now
          form.append(key, (formData as any)[key]);
        }
      }

      if (formData.uploadFiles && Array.isArray(formData.uploadFiles)) {
        for (let i = 0; i < formData.uploadFiles.length; i++) {
          const base64File = formData.uploadFiles[i];
          let filename = "";

          let realFileName = fileNames.find(
            (item) => item.fileUrl === base64File
          )?.fileName;

          if (realFileName) {
            filename = realFileName;
          } else {
            const match = base64File.match(/data:([^;]+);base64/);
            if (!match) {
              throw new Error(`Invalid Base64 format for file at index ${i}`);
            }

            const mimeType = match[1];
            const extension = mimeType.split("/")[1];
            filename = `file${i}.${extension}`;
          }

          const blob = await fetch(base64File).then((res) => res.blob());
          form.append("UploadFiles", blob, filename);
        }
      }

      const { data } = await client.post<QuotationRequestInterface>(url, form);

      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async Update(
    item: QuotationRequestInterface,
    fileNames: {
      fileUrl: string;
      fileName: string;
    }[]
  ) {
    try {
      const { id, vendor, ...formData } = item;
      const url = `/api/QuotationRequests/update/${id}`;

      const form = new FormData();

      for (const key in formData) {
        if (key !== "uploadFiles" && (key as string) !== "files") {
          form.append(key, (item as any)[key]);
        }
      }

      formData.files &&
        formData.files.forEach((file: any, index: number) => {
          delete file.extension;
          form.append(`files[${index}][fileUrl]`, file.fileUrl);
          form.append(`files[${index}][fileSize]`, file.fileSize);
          form.append(`files[${index}][fileName]`, file.fileName);
        });

      if (formData.uploadFiles && Array.isArray(formData.uploadFiles)) {
        for (let i = 0; i < item.uploadFiles.length; i++) {
          const base64File = item.uploadFiles[i];

          let filename = "";
          let realFileName = fileNames.find(
            (item) => item.fileUrl === base64File
          );
          if (realFileName && realFileName.fileName) {
            filename = realFileName.fileName;
          } else {
            const match = base64File.match(/data:([^;]+);base64/);
            if (!match) {
              throw new Error(`Invalid Base64 format for file at index ${i}`);
            }
            const mimeType = match[1];
            const extension = mimeType.split("/")[1];
            filename = `file${i}.${extension}`;
          }

          const blob = await fetch(base64File).then((res) => res.blob());
          form.append("UploadFiles", blob, filename);
        }
      }

      const { data } = await client.post<QuotationRequestInterface>(url, form);

      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async Remove(id: string) {
    try {
      const { data } = await client.post<QuotationRequestInterface>(
        `/api/QuotationRequests/remove/${id}`,
        { url: "" }
      );
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
}

export default new QuotationRequestService();
